import React, { useContext, useEffect, useState } from 'react'

import StoreContext from '~/context/StoreContext'
import {
  Wrapper,
  Info,
  ItemImage,
  Title,
  Price,
  SelectedOptions,
  QuantityContainer,
  QuantityButton,
  Quantity,
  InfoRight,
  SelectedOption,
  DeleteButton,
} from './styles'
import { ClickableIcon } from '~/styles/global'

import { getPrice, getVariantColor, getVariantSize } from '~/utils/helpers'

import IcDelete from '../../../images/ic-delete.svg'

const initialState = {
  options: {
    color: '',
    size: '',
  },
}

const LineItem = props => {
  const [state, setstate] = useState(initialState)
  const { line_item } = props

  useEffect(() => {
    setstate(prevState => ({
      ...prevState,
      options: {
        ...prevState.options,
      },
      selectedOptions: line_item.variant,
    }))
  }, [])

  const {
    removeLineItem,
    updateLineItem,
    store: { client, checkout },
  } = useContext(StoreContext)

  const variantImage = line_item.variant.image ? (
    <ItemImage src={line_item.variant.image.src} alt={`${line_item.title} product shot`} height="60px" />
  ) : null

  const selectedOptions = line_item.variant.selectedOptions
    ? line_item.variant.selectedOptions.map(option => `${option.name}: ${option.value} `)
    : ''

  const handleRemove = () => {
    removeLineItem(client, checkout.id, line_item.id)
  }

  const handleUpdate = quantity => {
    updateLineItem(client, checkout.id, line_item.id, quantity)
  }

  const decrementQuantity = currentQuantity => {
    handleUpdate(currentQuantity - 1)
  }

  const incrementQuantity = currentQuantity => {
    handleUpdate(currentQuantity + 1)
  }

  return (
    <Wrapper>
      {variantImage}
      <Info>
        <Title>{line_item.title}</Title>
        <SelectedOptions>
          {selectedOptions && <SelectedOption>{selectedOptions}</SelectedOption>}
        </SelectedOptions>
        <QuantityContainer>
          <QuantityButton onClick={() => decrementQuantity(line_item.quantity)}>-</QuantityButton>
          <Quantity>{line_item.quantity}</Quantity>
          <QuantityButton onClick={() => incrementQuantity(line_item.quantity)}>+</QuantityButton>
        </QuantityContainer>
      </Info>
      <InfoRight>
        <Price>{getPrice(checkout, line_item.variant.price)}</Price>
        <DeleteButton onClick={handleRemove}>
          <IcDelete alt="delete line item icon" />
        </DeleteButton>
      </InfoRight>
    </Wrapper>
  )
}

export default LineItem
